/**
 * Returns the given string in a North American Numbering Plan format:
 * (xxx) xxx-xxxx
 *
 * Notes:
 * - ignores characters after 10 digits
 * - if given string has less then 3 digits, returns the string as is
 * - if given string has more than 3 digits but less than 7, adds paranthesis and returns the string as (xxx) x
 * - if given string has more than 6 digits, returns the string as (xxx) xxx-xxxx
 *
 * @param number numeric characters
 */
export function formatToNorthAmericanNumber(number: string) {
  const areaCode = number.slice(0, 3);
  const centralOfficeCode = number.slice(3, 6);
  const lineNumber = number.slice(6, 10);
  // format number as (xxx) xxx-xxxx
  const formattedVal =
    `${number.length > 3 ? '(' + areaCode + ')' : areaCode} ${centralOfficeCode}${number.length <= 6 ? '' : '-'}${lineNumber}`.trim();
  return formattedVal;
}
